// Mantún (13-10-2026, copia del arreglo de FunFungi): precios del bloque «Agrégalos a tu carrito» (bundle-deals de Shrine).
// 1) Shrine reescribe los precios con '$' + (centavos / 100).toFixed(2) y salía «$56970.00»;
//    aquí se escriben en pesos chilenos («$56.970»).
// 2) Cada producto muestra lo que cobra Kaching por 1 unidad (p. ej. el kit −5 %), con el precio de lista
//    tachado. Kaching aplica ese descuento en el carrito aunque el producto no se agregue desde su widget
//    (probado en FunFungi en /cart.js el 12-10-2026). La escalera se lee de la ficha de cada producto.
//    Si falla, queda el precio de lista.
// El código de Shrine vive fuera del tema (js.shrinetheme.com), por eso se reemplaza el método desde aquí.
// Se carga desde snippets/mt-tienda.liquid.
(function () {
  if (window.mtBundlePrecios) return;
  window.mtBundlePrecios = true;

  var GUARDA = 'mt:kaching1:';
  var VIGENCIA = 10 * 60 * 1000;
  var kaching = {}; // handle → { tipo, valor } | null (sin descuento conocido)
  var pedidos = {};

  function plata(pesos) {
    return '$' + Math.round(pesos).toLocaleString('es-CL');
  }

  function handleDe(enlace) {
    var m = enlace && /\/products\/([^/?#]+)/.exec(enlace.getAttribute('href') || '');
    return m ? decodeURIComponent(m[1]) : null;
  }

  // Regla de 1 unidad de Kaching (misma lógica que precioKachingDesdeHtml del quiz).
  function reglaDesdeHtml(html) {
    var m = /<script[^>]*kaching-bundles-deal-block-settings[^>]*>([\s\S]*?)<\/script>/.exec(html);
    if (!m) return null;
    var cfg;
    try { cfg = JSON.parse(m[1]); } catch (e) { return null; }
    var barra = (cfg.dealBars || []).filter(function (b) { return (b.quantity || 1) === 1 && b.dealBarType !== 'bxgy'; })[0];
    if (!barra) return null;
    return { tipo: barra.discountType, valor: Number(barra.discountValue) || 0 };
  }

  function precioReal(lista, regla) {
    if (!regla) return lista;
    if (regla.tipo === 'percentage') return Math.round(lista * (1 - regla.valor / 100));
    if (regla.tipo === 'amount') return Math.max(0, lista - regla.valor);
    if (regla.tipo === 'specific') return regla.valor;
    return lista;
  }

  function pedirRegla(handle) {
    if (handle in kaching) return Promise.resolve();
    if (pedidos[handle]) return pedidos[handle];
    try {
      var g = JSON.parse(sessionStorage.getItem(GUARDA + handle) || 'null');
      if (g && Date.now() - g.ts < VIGENCIA) { kaching[handle] = g.regla; return Promise.resolve(); }
    } catch (e) { /* sin sessionStorage */ }
    pedidos[handle] = fetch('/products/' + encodeURIComponent(handle), { credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.text() : ''; })
      .then(function (html) {
        kaching[handle] = reglaDesdeHtml(html);
        try { sessionStorage.setItem(GUARDA + handle, JSON.stringify({ regla: kaching[handle], ts: Date.now() })); } catch (e) { /* nada */ }
      })
      .catch(function () { kaching[handle] = null; });
    return pedidos[handle];
  }

  function handles(el) {
    return Array.prototype.map.call(el.checkboxes || [], function (cb) {
      var i = parseInt(cb.dataset.index, 10);
      return handleDe(el.mediaItemContainers && el.mediaItemContainers[i]);
    });
  }

  // Reemplaza updateTotalPrice de Shrine: escribe cada precio y el total. Shrine lo llama al marcar
  // o desmarcar un producto y al cambiar de variante (después de escribir el precio con su formato).
  function pintar() {
    var el = this;
    if (!el.checkboxes || !el.totalPrice) return;
    var hs = handles(el);
    var total = 0, totalAntes = 0;
    el.checkboxes.forEach(function (cb, n) {
      var i = parseInt(cb.dataset.index, 10);
      var s = el.selectedVariants && el.selectedVariants[cb.dataset.idIndex];
      if (!s) return;
      var lista = parseInt(s.price, 10) / 100;
      var comparado = Math.max(lista, (parseInt(s.comparePrice, 10) || 0) / 100);
      var real = precioReal(lista, kaching[hs[n]]);
      var antes = Math.max(comparado, real);
      if (el.prices[i]) el.prices[i].textContent = plata(real);
      if (el.comparePrices[i]) el.comparePrices[i].textContent = antes > real ? plata(antes) : '';
      if (s.checked) { total += real; totalAntes += antes; }
    });
    var fijo = (parseFloat(el.fixedDiscount) || 0) / 100;
    var pct = isNaN(el.percentageLeft) ? 1 : el.percentageLeft;
    var final = total * pct - fijo;
    el.totalPrice.textContent = plata(final);
    if (el.totalComparePrice) el.totalComparePrice.textContent = totalAntes > final ? plata(totalAntes) : '';
  }

  function preparar(el) {
    if (el.mtPreparado) return;
    el.mtPreparado = true;
    pintar.call(el);
    var cargar = function () {
      Promise.all(handles(el).filter(Boolean).map(pedirRegla)).then(function () { pintar.call(el); });
    };
    if (!('IntersectionObserver' in window)) { cargar(); return; }
    // Las fichas se piden solo cuando el bloque se acerca a la pantalla.
    var io = new IntersectionObserver(function (entradas) {
      if (!entradas.some(function (e) { return e.isIntersecting; })) return;
      io.disconnect();
      cargar();
    }, { rootMargin: '1200px 0px' });
    io.observe(el);
  }

  customElements.whenDefined('bundle-deals').then(function () {
    var Clase = customElements.get('bundle-deals');
    if (!Clase || !Clase.prototype || typeof Clase.prototype.updateTotalPrice !== 'function') return;
    Clase.prototype.updateTotalPrice = pintar;
    document.querySelectorAll('bundle-deals').forEach(preparar);
    // Sección recargada en el editor de temas.
    document.addEventListener('shopify:section:load', function (e) {
      e.target.querySelectorAll('bundle-deals').forEach(preparar);
    });
  });
})();
